module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_7016.7a426de6.png";